import React from "react";
import ChapterResult from "./chapterResult";
import FiguresOverlay from "./overlay";
import { Isvg } from "../../components";

class ChapterResults extends React.Component {
  constructor() {
    super();
    this.state = {
      loadImage: 50,
      loadCard: 250
    };

    this._scrollFigures = this._scrollFigures.bind(this);
    this._loadMoreImages = this._loadMoreImages.bind(this);
    this._loadMoreCards = this._loadMoreCards.bind(this);
  }

  _loadMoreImages() {
    this.setState(prevState => ({ loadImage: prevState.loadImage + 25 }));
  }

  _loadMoreCards() {
    this.setState(prevState => ({ loadCard: prevState.loadCard + 250 }));
  }

  _scrollFigures() {
    const { chapters, sortOrder } = this.props;
    const sortedChapters =
      sortOrder === "az" ? chapters : chapters.slice().reverse();
    const figures = sortedChapters.reduce(
      (acc, ch) => acc.concat(ch.figures),
      []
    );
    const { loadCard, loadImage } = this.state;
    const cardFigure = figures[loadCard - 125];
    let figureId = cardFigure && cardFigure.figureId;
    let el = figureId && document.getElementById(`figure-${figureId}`);

    if (
      el &&
      (Fraction.Helpers.isScrolledIntoView(el) ||
        Fraction.Helpers.wasScrolledIntoView(el))
    ) {
      this._loadMoreCards();
    }
    const imageFigure = figures[loadImage - 25];
    figureId = imageFigure && imageFigure.figureId;
    el = figureId && document.getElementById(`figure-${figureId}`);
    if (
      el &&
      (Fraction.Helpers.isScrolledIntoView(el) ||
        Fraction.Helpers.wasScrolledIntoView(el))
    ) {
      this._loadMoreImages();
    }
  }

  render() {
    const {
      chapters,
      closeFigure,
      enlargeFigure,
      goToPreviousFigure,
      goToNextFigure,
      isbn,
      sortOrder
    } = this.props;
    const sortedChapters =
      sortOrder === "az" ? chapters : chapters.slice().reverse();
    let count = 0;
    if (chapters.length < 1) {
      return (
        <div id="toc-no-results">
          <ul className="no-results">
            <div id="toc-error-container">
              <Isvg id="laptop-no" src={"/img/prop_laptop_no.svg"}>
                NS
              </Isvg>
              <div id="error-message-one">
                {i18n.t("reader.figures.nothing-here")}{" "}
              </div>
              <div id="error-message-two">
                <div>{i18n.t("reader.figures.check-spelling")}</div>
              </div>
            </div>
          </ul>
        </div>
      );
    }
    return (
      <div className="chapter-results-container">
        <ul className="chapter-results" onScroll={this._scrollFigures}>
          {sortedChapters.map(chapter => {
            if (count < this.state.loadCard) {
              const previousFiguresCount = count;
              count += chapter.figures.length;
              return (
                <ChapterResult
                  key={chapter.title}
                  enlargeFigure={enlargeFigure}
                  figures={chapter.figures}
                  loadImageIndex={this.state.loadImage}
                  previousFiguresCount={previousFiguresCount}
                  title={chapter.title}
                />
              );
            }
          })}
        </ul>
      </div>
    );
  }
}

export default ChapterResults;
